import React, { createContext, useState, useContext, useEffect } from 'react';

const FavoritesContext = createContext();

export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavorites must be used within FavoritesProvider');
  }
  return context;
};

export const FavoritesProvider = ({ children }) => {
  const [favorites, setFavorites] = useState(() => {
    const savedFavorites = localStorage.getItem('favorites');
    return savedFavorites ? JSON.parse(savedFavorites) : [];
  });

  useEffect(() => {
    localStorage.setItem('favorites', JSON.stringify(favorites));
  }, [favorites]);

  const addToFavorites = (product) => {
    setFavorites(prevItems => {
      const exists = prevItems.find(item => item._id === product._id);
      if (exists) {
        return prevItems;
      }
      return [...prevItems, { ...product }];
    });
  };

  const removeFromFavorites = (productId) => {
    setFavorites(prevItems => prevItems.filter(item => item._id !== productId));
  };

  const isFavorite = (productId) => {
    return favorites.some(item => item._id === productId);
  };

  const clearFavorites = () => {
    setFavorites([]);
  };

  const getFavoritesCount = () => {
    return favorites.length;
  };

  return (
    <FavoritesContext.Provider
      value={{
        favorites,
        addToFavorites,
        removeFromFavorites,
        isFavorite,
        clearFavorites,
        getFavoritesCount
      }}
    >
      {children}
    </FavoritesContext.Provider>
  );
};
